<app-tabla-general [displayedColumns]="displayedColumns" [moduloActual]="'visitantes'" [tabsVisitantes]="estadosTabs" (tipoVisitasChange)="onTipoVisitasChange($event)"></app-tabla-general>
<router-outlet></router-outlet>